import { createApiSlice } from 'app/createApiSlice'
import {
  API_FARMERS_REGISTER_V2,
  API_LINKTAGS,
  API_PROJECT_SUMMARY_DASHBOARD,
  API_PROJECTS_MENU,
  API_SHARE_ACCESS,
  API_SHARE_PROJECT,
  API_SHARE_PROJECT_SUMMARY,
  API_FIND_ADDDRESS_BOOK,
} from 'utils/apiList'

export const parseNumericFilter = (paramName, rawValue) => {
  if (rawValue === undefined || rawValue === null) return {}
  const str = String(rawValue).trim()
  if (!str) return {}

  const result = {}

  // 1. Cek pola rentang dengan dash atau 'to': misal "0 - 50" atau "100 to 500"
  const rangePattern = /^(\d+(?:\.\d+)?)\s*(?:-|to)\s*(\d+(?:\.\d+)?)$/i
  const rangeMatch = str.match(rangePattern)
  if (rangeMatch) {
    result[`${paramName}[gte]`] = rangeMatch[1]
    result[`${paramName}[lte]`] = rangeMatch[2]
    return result
  }

  // 2. Ekstrak ekspresi beroperator: >=, <=, >, <, ==, =, gte, lte, gt, lt, eq
  const tokenRegex = /(>=|<=|>|<|==|=|gte|lte|gt|lt|eq)\s*(-?\d+(?:\.\d+)?)/gi
  let match
  let foundAny = false

  while ((match = tokenRegex.exec(str)) !== null) {
    foundAny = true
    const op = match[1].toLowerCase()
    const val = match[2]

    let mappedOp = 'eq'
    if (op === '>=' || op === 'gte') mappedOp = 'gte'
    else if (op === '<=' || op === 'lte') mappedOp = 'lte'
    else if (op === '>' || op === 'gt') mappedOp = 'gt'
    else if (op === '<' || op === 'lt') mappedOp = 'lt'
    else if (op === '=' || op === '==' || op === 'eq') mappedOp = 'eq'

    result[`${paramName}[${mappedOp}]`] = val
  }

  // 3. Jika tidak ada operator eksplisit yang cocok, cek jika seluruh string adalah angka tunggal
  if (!foundAny) {
    const singleNumMatch = str.match(/^(-?\d+(?:\.\d+)?)$/)
    if (singleNumMatch) {
      result[`${paramName}[eq]`] = singleNumMatch[1]
    }
  }

  return result
}

export const projectsMenuListApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'projectsMenuList/api',
  endpoints(builder) {
    return {
      fetchProjectsList: builder.query({
        query({
          sortby = 'createdAt',
          sortdir = 'DESC',
          search,
          page = 0,
          size = 10,
          status = undefined,
          from,
          to,
          type,
          workerUserIds,
          targetIds,
          goal,
          goalMin,
          goalMax,
          completion,
          completionMin,
          completionMax,
          completion_progress,
        }) {
          const goalParams = parseNumericFilter('goal', goal)
          const completionParams = parseNumericFilter('completion', completion)

          const formattedWorkerUserIds = Array.isArray(workerUserIds)
            ? workerUserIds.filter(Boolean).join(',')
            : workerUserIds
          const formattedTargetIds = Array.isArray(targetIds)
            ? targetIds.filter(Boolean).join(',')
            : targetIds

          const params = {
            sortby,
            sortdir,
            search,
            page,
            size,
            status,
            from,
            to,
            type,
            ...(formattedWorkerUserIds
              ? { workerUserIds: formattedWorkerUserIds }
              : {}),
            ...(formattedTargetIds ? { targetIds: formattedTargetIds } : {}),
            ...(completion_progress !== undefined &&
            completion_progress !== null &&
            completion_progress !== ''
              ? { completion_progress }
              : {}),
            ...goalParams,
            ...completionParams,
            ...(goalMin !== undefined && goalMin !== null && goalMin !== ''
              ? { 'goal[gte]': goalMin }
              : {}),
            ...(goalMax !== undefined && goalMax !== null && goalMax !== ''
              ? { 'goal[lte]': goalMax }
              : {}),
            ...(completionMin !== undefined &&
            completionMin !== null &&
            completionMin !== ''
              ? { 'completion[gte]': completionMin }
              : {}),
            ...(completionMax !== undefined &&
            completionMax !== null &&
            completionMax !== ''
              ? { 'completion[lte]': completionMax }
              : {}),
          }

          if (status === undefined || status === null || status === '') {
            delete params.status
          }
          if (!from) delete params.from
          if (!to) delete params.to
          if (!type) delete params.type

          params.withSummary = 1

          return {
            url: `/${API_PROJECTS_MENU}`,
            params,
          }
        },
      }),
      fetchProjectById: builder.query({
        query({ projectId }) {
          return {
            url: `/${API_PROJECTS_MENU}/${projectId}`,
          }
        },
      }),
      fetchProjectSummaryById: builder.query({
        query({ projectId }) {
          return {
            url: `/${API_PROJECT_SUMMARY_DASHBOARD}/${projectId}`,
          }
        },
      }),
      fetchProjectLogsById: builder.query({
        query({ projectId }) {
          return {
            url: `/${API_PROJECTS_MENU}/${projectId}/logs`,
          }
        },
      }),
      createProjectMenu: builder.mutation({
        query(payload) {
          return {
            url: API_PROJECTS_MENU,
            method: 'POST',
            body: payload,
          }
        },
      }),
      updateProjectMenu: builder.mutation({
        query({ projectId, payload }) {
          return {
            url: `${API_PROJECTS_MENU}/${projectId}`,
            method: 'PUT',
            body: payload,
          }
        },
      }),
      fetchFarmersProject: builder.query({
        query({
          s,
          page = 0,
          size = 9999,
          sortby = 'createdAt',
          sortdir = 'DESC',
        }) {
          const params = {
            s,
            page,
            size,
            sortby,
            sortdir,
          }

          return {
            url: API_FARMERS_REGISTER_V2,
            params,
          }
        },
      }),
      fetchProjectShareContacts: builder.query({
        keepUnusedDataFor: 3600,
        async queryFn(
          { s = '', page = 0, size = 10 } = {},
          _queryApi,
          _extraOptions,
          baseQuery,
        ) {
          const response = await baseQuery({
            url: API_FIND_ADDDRESS_BOOK,
            params: {
              s,
              page,
              size,
              sortby: 'createdAt',
              sortdir: 'desc',
              isPhoneRegistered: 1,
              isEmailRegistered: 1,
              isNetwork: 1,
              isTeam: 1,
            },
          })
          if (response.error) {
            return { error: response.error }
          }

          const extractItems = (res) => {
            const body = res?.data
            if (Array.isArray(body)) return body
            if (Array.isArray(body?.items)) return body.items
            if (Array.isArray(body?.data)) return body.data
            if (Array.isArray(body?.data?.items)) return body.data.items
            if (Array.isArray(body?.data?.data?.items))
              return body.data.data.items
            return []
          }

          const state = _queryApi?.getState?.() || {}
          const loggedInUserId =
            state?.dashboard?.profile?.userId ??
            state?.dashboard?.ownerData?.userId ??
            (() => {
              try {
                const u =
                  JSON.parse(localStorage.getItem('userData')) ||
                  JSON.parse(localStorage.getItem('_user'))
                return u?.userId ?? u?.id ?? null
              } catch {
                return null
              }
            })()

          const rawContacts = extractItems(response)
          const normalizedContacts = rawContacts
            .filter((contact) => {
              const accountUserId =
                contact.relationUserId ?? contact.relationEmailUserId ?? null
              // Sembunyikan user yang sedang login jika ada di kontak
              if (
                loggedInUserId &&
                accountUserId &&
                String(accountUserId) === String(loggedInUserId)
              ) {
                return false
              }
              return true
            })
            .map((contact) => {
              // Untuk address book: id adalah relationUserId atau relationEmailUserId (BUKAN userId pemilik)
              const accountUserId =
                contact.relationUserId ?? contact.relationEmailUserId ?? null

              return {
                ...contact,
                userId: accountUserId,
                relationUserId: accountUserId,
                relationName:
                  contact.relationName ||
                  contact.fullName ||
                  contact.name ||
                  contact.relationEmail ||
                  contact.email ||
                  contact.relationPhoneNumber ||
                  contact.phoneNumber,
                relationEmail:
                  contact.relationEmail || contact.email || contact.phoneNumber,
                relationPhoneNumber:
                  contact.relationPhoneNumber ||
                  contact.phoneNumber ||
                  contact.phone ||
                  contact.mobileNumber,
                profile_img:
                  contact.profile_img || contact.profileImg || contact.avatar,
              }
            })
          const body = response?.data || {}
          const totalItems =
            body?.totalItems ?? body?.data?.totalItems ?? rawContacts.length
          const totalPages =
            body?.totalPages ??
            body?.data?.totalPages ??
            (size > 0 ? Math.ceil(totalItems / size) : 1)
          const hasMore =
            page + 1 < totalPages ||
            (rawContacts.length >= size && rawContacts.length > 0)

          return {
            data: {
              items: normalizedContacts,
              totalItems,
              totalPages,
              currentPage: page,
              hasMore,
            },
          }
        },
      }),
      deleteProject: builder.mutation({
        query({ projectId }) {
          return {
            url: `${API_PROJECTS_MENU}/${projectId}`,
            method: 'DELETE',
          }
        },
      }),
      createLinkTags: builder.mutation({
        query(payload) {
          return {
            url: API_LINKTAGS,
            method: 'POST',
            body: payload,
          }
        },
      }),
      fetchLinkTags: builder.query({
        query({ linkDocs, page = 0, size = 50 }) {
          return {
            url: API_LINKTAGS,
            params: {
              linkDocs,
              page,
              size,
            },
          }
        },
      }),
      shareProject: builder.mutation({
        query(payload) {
          return {
            url: API_SHARE_ACCESS,
            method: 'POST',
            body: payload,
          }
        },
      }),
      revokeAccessToProject: builder.mutation({
        query(payload) {
          return {
            url: API_SHARE_ACCESS,
            method: 'DELETE',
            body: payload,
          }
        },
      }),
      listResourcesAccess: builder.query({
        query({ resourceId, resourceType = 'PROJECT' }) {
          return {
            url: API_SHARE_ACCESS,
            params: {
              resourceType,
              resourceId,
            },
          }
        },
      }),
      getSharedProject: builder.query({
        query({
          page = 0,
          size = 10,
          sortby,
          sortdir,
          status,
          from,
          to,
          search,
          workerUserIds,
          targetIds,
          goal,
          goalMin,
          goalMax,
          completion,
          completionMin,
          completionMax,
          completion_progress,
        } = {}) {
          const goalParams = parseNumericFilter('goal', goal)
          const completionParams = parseNumericFilter('completion', completion)

          const formattedWorkerUserIds = Array.isArray(workerUserIds)
            ? workerUserIds.filter(Boolean).join(',')
            : workerUserIds
          const formattedTargetIds = Array.isArray(targetIds)
            ? targetIds.filter(Boolean).join(',')
            : targetIds

          const params = {
            page,
            size,
            sortby,
            sortdir,
            status,
            from,
            to,
            search,
            withSummary: 1,
            ...(formattedWorkerUserIds
              ? { workerUserIds: formattedWorkerUserIds }
              : {}),
            ...(formattedTargetIds ? { targetIds: formattedTargetIds } : {}),
            ...(completion_progress !== undefined &&
            completion_progress !== null &&
            completion_progress !== ''
              ? { completion_progress }
              : {}),
            ...goalParams,
            ...completionParams,
            ...(goalMin !== undefined && goalMin !== null && goalMin !== ''
              ? { 'goal[gte]': goalMin }
              : {}),
            ...(goalMax !== undefined && goalMax !== null && goalMax !== ''
              ? { 'goal[lte]': goalMax }
              : {}),
            ...(completionMin !== undefined &&
            completionMin !== null &&
            completionMin !== ''
              ? { 'completion[gte]': completionMin }
              : {}),
            ...(completionMax !== undefined &&
            completionMax !== null &&
            completionMax !== ''
              ? { 'completion[lte]': completionMax }
              : {}),
          }
          if (status === undefined || status === null || status === '') {
            delete params.status
          }
          if (!from) delete params.from
          if (!to) delete params.to

          return {
            url: API_SHARE_PROJECT,
            params,
          }
        },
      }),
      sharedProjectDetail: builder.query({
        query({ id }) {
          return {
            url: `${API_SHARE_PROJECT}/${id}`,
          }
        },
      }),
      updateProjectMenuShared: builder.mutation({
        query({ projectId, payload }) {
          return {
            url: `${API_SHARE_PROJECT}/${projectId}`,
            method: 'PUT',
            body: payload,
          }
        },
      }),
      fetchProjectSummarySharedById: builder.query({
        query({ projectId }) {
          return {
            url: `${API_SHARE_PROJECT_SUMMARY}/${projectId}`,
          }
        },
      }),
    }
  },
})

export const {
  useFetchProjectsListQuery,
  useLazyFetchProjectsListQuery,
  useFetchProjectByIdQuery,
  useLazyFetchProjectByIdQuery,
  useFetchProjectSummaryByIdQuery,
  useLazyFetchProjectSummaryByIdQuery,
  useFetchProjectLogsByIdQuery,
  useCreateProjectMenuMutation,
  useLazyCreateProjectMenuMutation,
  useUpdateProjectMenuMutation,
  useLazyUpdateProjectMenuMutation,
  useFetchFarmersProjectQuery,
  useLazyFetchFarmersProjectQuery,
  useFetchProjectShareContactsQuery,
  useLazyFetchProjectShareContactsQuery,
  useDeleteProjectMutation,
  useCreateLinkTagsMutation,
  useFetchLinkTagsQuery,
  useShareProjectMutation,
  useRevokeAccessToProjectMutation,
  useListResourcesAccessQuery,
  useLazyListResourcesAccessQuery,
  useGetSharedProjectQuery,
  useLazyGetSharedProjectQuery,
  useSharedProjectDetailQuery,
  useLazySharedProjectDetailQuery,
  useUpdateProjectMenuSharedMutation,
  useFetchProjectSummarySharedByIdQuery,
  useLazyFetchProjectSummarySharedByIdQuery,
} = projectsMenuListApiSlice
